export default [
  {
    inputs: [],
    name: "AppealExists",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidAppealDecision",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidDuration",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidExpiry",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidMaxPaymentTimeLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidMinPaymentTimeLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidOrderCreateState",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidOrderMethodCall",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidQuantity",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTradeToken",
    type: "error",
  },
  {
    inputs: [],
    name: "MustBeAppealer",
    type: "error",
  },
  {
    inputs: [],
    name: "MustBeMerchant",
    type: "error",
  },
  {
    inputs: [],
    name: "MustBeMerchantOrTrader",
    type: "error",
  },
  {
    inputs: [],
    name: "MustBeTrader",
    type: "error",
  },
  {
    inputs: [],
    name: "NotYetDeadline",
    type: "error",
  },
  {
    inputs: [],
    name: "OrderAcceptedRequired",
    type: "error",
  },
  {
    inputs: [],
    name: "OrderAlreadyAppealed",
    type: "error",
  },
  {
    inputs: [],
    name: "OrderAppealedRequired",
    type: "error",
  },
  {
    inputs: [],
    name: "OrderDoesNotExists",
    type: "error",
  },
  {
    inputs: [],
    name: "OrderExists",
    type: "error",
  },
  {
    inputs: [],
    name: "OrderExpired",
    type: "error",
  },
  {
    inputs: [],
    name: "OrderPaidRequired",
    type: "error",
  },
  {
    inputs: [],
    name: "OrderPendingOrAcceptedRequired",
    type: "error",
  },
  {
    inputs: [],
    name: "OrderPendingRequired",
    type: "error",
  },
  {
    inputs: [],
    name: "TradeTokenDoesNotExists",
    type: "error",
  },
  {
    inputs: [],
    name: "TradeTokenExists",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "appealer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum IAppeal.AppealDecision",
        name: "appealDecision",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "enum OrderState",
        name: "orderState",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cancelledAt",
        type: "uint256",
      },
    ],
    name: "AppealCancelled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "appealer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "settler",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum IAppeal.AppealDecision",
        name: "appealDecision",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "enum OrderState",
        name: "orderState",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "settledAt",
        type: "uint256",
      },
    ],
    name: "AppealSettled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256",
      },
    ],
    name: "MaxPaymentTimeLimitSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256",
      },
    ],
    name: "MinPaymentTimeLimitSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "traderChain",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "merchantChain",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "currency",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "paymentMethod",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "enum OrderType",
        name: "orderType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum OrderState",
        name: "orderState",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "createdAt",
        type: "uint256",
      },
    ],
    name: "NewOrder",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "enum OrderState",
        name: "status",
        type: "uint8",
      },
    ],
    name: "OrderAccepted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "appealer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum IAppeal.AppealDecision",
        name: "appealDecision",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "enum OrderState",
        name: "orderState",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "createdAt",
        type: "uint256",
      },
    ],
    name: "OrderAppealed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "enum OrderState",
        name: "status",
        type: "uint8",
      },
    ],
    name: "OrderCancelled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "enum OrderState",
        name: "status",
        type: "uint8",
      },
    ],
    name: "OrderPaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "enum OrderState",
        name: "status",
        type: "uint8",
      },
    ],
    name: "OrderReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "crossChainHandler",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "collectedFees",
        type: "uint256",
      },
    ],
    name: "TradeTokenAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "TradeTokenRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "crossChainHandler",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "orderFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "collectedFees",
        type: "uint256",
      },
    ],
    name: "TradeTokenUpdated",
    type: "event",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum IOrderSig.OrderMethod",
            name: "method",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
        ],
        internalType: "struct IOrderSig.OrderMethodPayload",
        name: "_method",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "acceptOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_orderHash",
        type: "bytes32",
      },
    ],
    name: "acceptOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_crossChainSender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_orderFee",
        type: "uint256",
      },
    ],
    name: "addTradeToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_orderHash",
        type: "bytes32",
      },
    ],
    name: "appeal",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "appealer",
            type: "address",
          },
          {
            internalType: "enum IAppeal.AppealDecision",
            name: "appealDecision",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cancelledAt",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "settler",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "settledAt",
            type: "uint256",
          },
        ],
        internalType: "struct IAppeal.Appeal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum IOrderSig.OrderMethod",
            name: "method",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
        ],
        internalType: "struct IOrderSig.OrderMethodPayload",
        name: "_method",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "appealOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_orderHash",
        type: "bytes32",
      },
    ],
    name: "appealOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_orderHash",
        type: "bytes32",
      },
    ],
    name: "cancelAppeal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum IOrderSig.OrderMethod",
            name: "method",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
        ],
        internalType: "struct IOrderSig.OrderMethodPayload",
        name: "_method",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "cancelAppeal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum IOrderSig.OrderMethod",
            name: "method",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
        ],
        internalType: "struct IOrderSig.OrderMethodPayload",
        name: "_method",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "cancelOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_orderHash",
        type: "bytes32",
      },
    ],
    name: "cancelOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "trader",
            type: "address",
          },
          {
            internalType: "address",
            name: "merchant",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "traderChain",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "merchantChain",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "currency",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "paymentMethod",
            type: "bytes32",
          },
          {
            internalType: "enum OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
        ],
        internalType: "struct IOrder.CreateOrder",
        name: "_order",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_traderSig",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "_merchantSig",
        type: "bytes",
      },
    ],
    name: "createOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "trader",
            type: "address",
          },
          {
            internalType: "address",
            name: "merchant",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "traderChain",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "merchantChain",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "currency",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "paymentMethod",
            type: "bytes32",
          },
          {
            internalType: "enum OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
        ],
        internalType: "struct IOrder.CreateOrder",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "createOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "maxPaymentTimeLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minPaymentTimeLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_orderHash",
        type: "bytes32",
      },
    ],
    name: "order",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "trader",
            type: "address",
          },
          {
            internalType: "address",
            name: "merchant",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "traderChain",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "merchantChain",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "currency",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "paymentMethod",
            type: "bytes32",
          },
          {
            internalType: "enum OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            internalType: "enum OrderState",
            name: "orderState",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256",
          },
        ],
        internalType: "struct IOrder.Order",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_orderHash",
        type: "bytes32",
      },
    ],
    name: "payOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum IOrderSig.OrderMethod",
            name: "method",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
        ],
        internalType: "struct IOrderSig.OrderMethodPayload",
        name: "_method",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "payOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_orderHash",
        type: "bytes32",
      },
    ],
    name: "releaseOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "enum IOrderSig.OrderMethod",
            name: "method",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
        ],
        internalType: "struct IOrderSig.OrderMethodPayload",
        name: "_method",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_sig",
        type: "bytes",
      },
    ],
    name: "releaseOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "removeTradeToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_val",
        type: "uint256",
      },
    ],
    name: "setMaxPaymentTimeLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_val",
        type: "uint256",
      },
    ],
    name: "setMinPaymentTimeLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_orderHash",
        type: "bytes32",
      },
      {
        internalType: "enum IAppeal.AppealDecision",
        name: "_appealDecision",
        type: "uint8",
      },
    ],
    name: "settleAppeal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
    ],
    name: "tradeToken",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "collectedFees",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "crossChainSender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "orderFee",
            type: "uint256",
          },
        ],
        internalType: "struct TradeToken",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_crossChainSender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_orderFee",
        type: "uint256",
      },
    ],
    name: "updateTradeToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;
